import { useEffect, useMemo, useState } from "react"
/**
 * @template T
 * @param {T} defaultValue
 */

export default function useProp(defaultValue) {
  const [value, setValue] = useState(defaultValue)

  return useMemo(() => ({
    value,
    setValue,
    valueOf: () => value,
    toString: () => value,
    toJSON: () => value,
  }), [value])
}

export function defineDataPropHook(prop) {
  return (data, { onChange } = {}) => {
    const property = useProp(prop ? data?.[prop] : data)
    const { setValue } = property

    useEffect(() => {
      setValue(prop ? data?.[prop] : data)
    }, [data, setValue])

    useEffect(() => {
      if (prop) {
        data[prop] = property.value
      }
    }, [data, property.value])

    return useMemo(() => ({
      ...property,
      setValue: value => {
        setValue(value)
        onChange?.(value)
      },
    }), [property, setValue, onChange])
  }
}

